module.exports = __webpack_public_path__ + "img/T1D_rc-13.c308ac10.png";